import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  // baseUrl: "https://api.mmitsol.com/",
  // baseUrl: "http://localhost:5001",
   //baseUrl: "https://stagingapi.acadimyst.com/",
   //baseUrl: "http://3.108.63.55:3000",
  baseUrl: "https://api.acadimyst.com/",
  //baseUrl: "http://192.168.18.22:3000",

  prepareHeaders: (headers, { getState }) => {
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
// 🔴 Custom wrapper to handle session expiration
const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // Handle different session expiration scenarios
  if (result?.error) {
    const { status, data } = result.error;

    // Check for various session expiration indicators
    const isSessionExpired =
      status === 401 ||
      status === 403 ||
      (data?.message &&
        (data.message.toLowerCase().includes("token expired") ||
          data.message.toLowerCase().includes("session expired") ||
          data.message.toLowerCase().includes("unauthorized") ||
          data.message.toLowerCase().includes("invalid token") ||
          data.message.toLowerCase().includes("jwt expired")));

    if (isSessionExpired) {
      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear any browser caches if needed
      if ("caches" in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }

      // Force redirect to login page immediately
      setTimeout(() => {
        window.location.replace("/login");
      }, 100);

      return result;
    }
  }

  // Also check if the response contains session expired message in the body
  if (result?.data && typeof result.data === "string") {
    const responseText = result.data.toLowerCase();
    if (
      responseText.includes("your session has expired") ||
      responseText.includes("session expired") ||
      responseText.includes("please log in again")
    ) {
      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();

      // Force redirect to login page immediately
      setTimeout(() => {
        window.location.replace("/login");
      }, 100);

      return result;
    }
  }

  return result;
};

// Check for session expiration on page load and periodically
const checkSessionExpiration = () => {
  // Check if page contains session expired message
  const pageText = document.body ? document.body.innerText.toLowerCase() : "";
  if (
    pageText.includes("your session has expired") ||
    pageText.includes("session expired")
  ) {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Force redirect to login page
    setTimeout(() => {
      window.location.replace("/login");
    }, 100);
  }

  // Check if token exists but might be expired
  const token = localStorage.getItem("token");
  const publicRoutes = [
    "/login",
    "/forgot-password",
    "/register",
    "/documentation",
    "/",
  ];
  const isPublicRoute = publicRoutes.includes(window.location.pathname);

  if (!token && !isPublicRoute) {
    // No token but not on public page - redirect to login
    setTimeout(() => {
      window.location.replace("/login");
    }, 100);
  }
};

// Run session check on load and periodically
if (typeof window !== "undefined") {
  // Check immediately when module loads
  setTimeout(checkSessionExpiration, 500);

  // Check every 5 seconds
  setInterval(checkSessionExpiration, 5000);

  // Check when page becomes visible
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      setTimeout(checkSessionExpiration, 500);
    }
  });
}

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  tagTypes: ["Login", "ListeningTests"],
  endpoints: (builder) => ({}), // add your endpoints here
});










